<h3>Vehículos Asociados a la Póliza</h3>
<p-table [value]="vehiculos" [paginator]="true" [rows]="5">
    <ng-template pTemplate="header">
        <tr>
            <th>Dominio</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-vehiculo>
        <tr>
            <td>{{ vehiculo.dominio }}</td>
        </tr>
    </ng-template>
</p-table>